// Public URL helper (works with GH Pages and custom domains)
export const PUBLIC = process.env.PUBLIC_URL || "";
export const assetUrl = (path) => `${PUBLIC}${path}`;

// Render avatar fallback if image fails or is absent
export function photoOrAvatar({ src, name = "", className = "" }) {
  if (!src) return <Avatar name={name} className={className} />;
  return (
    <img
      src={src}
      alt="Profile"
      className={className}
      draggable={false}
      onContextMenu={(e) => e.preventDefault()} // light deterrent
      onError={(e) => {
        // Replace with avatar if image fails to load
        const node = e.currentTarget;
        if (node && node.parentElement) {
          const wrapper = node.parentElement;
          node.style.display = "none";
          const avatar = document.createElement("div");
          avatar.className =
            "no-export w-28 h-28 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-[#A7C7E7] to-[#60A5FA] flex items-center justify-center text-white text-2xl font-semibold select-none shadow ring-1 ring-slate-200 dark:ring-slate-700";
          avatar.textContent = initials(name);
          wrapper.appendChild(avatar);
        }
      }}
    />
  );
}

function initials(name = "") {
  return name
    .split(/\s+/)
    .map((n) => n[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function AvatarJSX({ name, className }) {
  return (
    <div
      className={
        className ||
        "no-export w-28 h-28 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-[#A7C7E7] to-[#60A5FA] flex items-center justify-center text-white text-2xl font-semibold select-none shadow ring-1 ring-slate-200 dark:ring-slate-700"
      }
    >
      {initials(name) || "SL"}
    </div>
  );
}

// convenience for React usage
function Avatar({ name = "", className = "" }) {
  return <AvatarJSX name={name} className={className} />;
}
